import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Settings } from '../interfaces/settings';
import { AuthService } from './auth.service';

// const defaultConfig: Settings = {
//   latest: false,
//   validFrom: null,
//   validTo: null,
//   value: {
//     categories: [
//       { 'description': 'Amministrazione', 'name': 'AMM' },
//       { 'description': 'Ingegnerizzazione esterna', 'name': 'ING' },
//       { 'description': 'Lavorazioni esterne', 'name': 'OFE' },
//       { 'description': 'Acquisto materiali e servizi', 'name': 'AMS' },
//       { 'description': 'Acquisto Vetri', 'name': 'AVT' },
//       { 'description': 'Acquisto Imballaggi', 'name': 'AIM' },
//       { 'description': 'Spedizioni Clienti Europa', 'name': 'SPE' },
//       { 'description': 'Trasporti Interni', 'name': 'TRI' },
//       { 'description': 'Trasporti esterni IT', 'name': 'TRE' },
//       { 'description': 'Ufficio tecnico', 'name': 'UFT' },
//       { 'description': 'Progettazione Interna', 'name': 'PRI' },
//       { 'description': 'Lavorazioni interne', 'name': 'OFI' }
//     ],
//     budgetCollection: 'ProvaBudgetCollectionDev_v03',
//     timereportCollection: 'TimeReportCollection',
//     firebaseApi: 'https://us-central1-extravega-management.cloudfunctions.net/api',
//     prosperworks: {
//       endpoint: 'http://localhost:9000/prosperworks',
//       headers: {
//         'content-type': 'application/json',
//         'x-pw-accesstoken': 'f2f2bbb4a75b21f8c75b957c22c1a626',
//         'x-pw-application': 'developer_api',
//         'x-pw-useremail': 'giacomo@i-sergio.com',
//       }
//     }
//   }
// };

const SETTINGS_COLLECTION = 'Settings';

@Injectable()
export class ConfigService {

  private settingsCollRef: AngularFirestoreCollection<any>;
  private _settings$ = new BehaviorSubject<Settings>(null);
  private readonly cDR: AngularFirestoreDocument<any>;

  get settings(): BehaviorSubject<Settings> {
    return this._settings$;
  }

  constructor(private afs: AngularFirestore, private auth: AuthService) {

    this.cDR = auth.customerDocumentReference;
    // Subscribe to Settings
    this.settingsCollRef = this.cDR.collection<Settings>(SETTINGS_COLLECTION,
      ref => ref.where('latest', '==', true));
    this.settingsCollRef.valueChanges()
      .map((aat) => aat[0])
      // .map((onLineSettings) => defaultsDeep(onLineSettings, defaultConfig))
      .do((sett) => console.log('Settings have changed!', sett))
      //  .map((sett) => {
      //    //PER DEBUG
      //    sett.value.firebaseApi = "http://localhost:5000/extravega-management-dev/us-central1/api";
      //    return sett;
      //  })
      .subscribe(this._settings$);

  }

}


// WEBPACK FOOTER //
// ./src/app/services/config.service.ts